import React, { useState } from 'react';
import { Accordion, Card, Checkbox, Divider, Flex, Grid, Loader, Modal, Stack, Text } from '@mantine/core';
import IcAgent from '../../components/icons/IcAgent';
import styles from './styles.scoped.css';
import GridCell from '../../components/elements/GridCell';
import SwitchCustom from '../../components/elements/SwitchCustom';
import PropTypes from 'prop-types';
import Button from '../../components/elements/Button';
import IconSuccess from '../../components/icons/IconSuccess';
import IconFailed from '../../components/icons/IconFailed';
import CardFeatureSummary from './fragments/CardFeatureSummary';
import { useNavigate } from 'react-router-dom';


export const RenderModalUpdateFeature = ({
  opened = false,
  setModal = () => {},
  data = {},
  onConfirm = () => {}
}) => {
  const defaultPolicy = data?.policy?.map(item => ({
    id: item.id,
    isActivated: item.isActivated
  }));
  const [payload, setPayload] = useState(defaultPolicy);
  const [isAgree, setIsAgree] = useState(false);

  const onClose = () => {
    setModal({
      opened: false
    });
    setIsAgree(false);
  };

  const handleChange = (e) => {
    const { value: id, checked } = e.target;
    setPayload(prev => prev.map(item => {
      if(item.id === id) {
        return {
          ...item,
          isActivated: checked
        };
      }else{
        return item;
      }}));
  };

  return(
    <Modal centered onClose={onClose} opened={opened} radius={12} size="lg" styles={{
      title: {
        fontWeight: 600,
        fontSize: 30
      },
      header: {
        gap: '1rem',
        alignItems: 'start'
      }
    }} title="Ubah Status Aktivasi Fitur MAP Pangkalan" w="36rem">
      <Card className={styles.cardModalContent} withBorder>
        <Flex align="center" gap="sm">
          <IcAgent/>
          <Text fw={600} fz={18}>{data?.storeName || '-'}</Text>
        </Flex>
        <GridCell data={data?.registrationId || '-'} label="ID Registrasi"/>
        <Divider/>
        <Text fw={600}>Aktivasi Fitur</Text>
        {/* <Switch.Group > */}
        <Stack>
          {data?.policy?.map((item, idx) => (
            <GridCell data={<Flex align="center" gap="xs">
            :<SwitchCustom defaultChecked={item.isActivated} offLabel="Tidak aktif" onChange={handleChange} onLabel="Aktif" size="xl" styles={{
                track: {
                  width: '6.563rem'
                }
              }} value={item.id}/>
            </Flex>} key={item.id + idx} label={<Text fw={400} fz="sm">{item.menu}</Text>}/>
          ))}
        </Stack>
        {/* </Switch.Group> */}
        <Checkbox checked={isAgree} label="Saya yakin untuk mengubah status aktivasi fitur MAP pangkalan" onChange={() => setIsAgree(!isAgree)} styles={{
          label: {
            fontWeight: 400,
            fontSize: 13
          },
          body: {
            alignItems: 'center'
          }
        }}/>
      </Card>
      <Flex gap="sm" mt="lg">
        <Button fullWidth onClick={onClose} outlined>
            Batal
        </Button>
        <Button disabled={!isAgree} fullWidth onClick={() => onConfirm(payload)} >
            Ubah Status
        </Button>
      </Flex>
    </Modal>
  );
};

RenderModalUpdateFeature.propTypes = {
  data: PropTypes.object,
  onConfirm: PropTypes.func,
  opened: PropTypes.bool,
  setModal: PropTypes.func
};

export const RenderModalBulkConfirmation = ({
  opened = false,
  onClose = () => {},
  onConfirm = () => {},
  type = 'activation',
  listFeature = [],
  selectedFeature = [],
  isLoading = false,
}) => {
  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return(
    <Modal
      centered
      closeOnClickOutside={!isLoading}
      closeOnEscape={!isLoading}
      onClose={handleClose}
      opened={opened}
      styles={{
        title: {
          fontSize: '30px',
          fontWeight: 600
        }
      }}
      title={`Konfirmasi ${type === 'activation' ? 'Aktivasi' : 'Nonaktifkan'} Fitur MAP`}
      w="36rem"
      withCloseButton={!isLoading}
    >
      <Stack>
        <Text c="#52575C" fz={18}>
        Apakah Anda yakin ingin {type === 'activation' ? 'mengaktifkan' : 'menonaktifkan'} fitur MAP pada pangkalan?
        </Text>
        <CardFeatureSummary listFeature={listFeature}
          selectedFeature={selectedFeature}
          type={type}/>
        <Flex gap="md">
          <Button
            disabled={isLoading}
            fullWidth
            onClick={handleClose}
            outlined
          >
            Periksa Kembali
          </Button>
          <Button disabled={isLoading} fullWidth onClick={onConfirm}>
            {isLoading ? <Loader color="gray" size="sm" /> : 'Simpan'}
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};

RenderModalBulkConfirmation.propTypes = {
  isLoading: PropTypes.bool,
  listFeature: PropTypes.array,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  opened: PropTypes.bool,
  selectedFeature: PropTypes.array,
  type: PropTypes.string
};

export const RenderModalSummaryBulkActivation = ({
  opened = false,
  onClose = () => {},
  summary = {
    failedDetails: [],
    failedTotal: 0,
    successTotal: 0
  },
  listFeature = [],
  selectedFeature = [],
  type = 'activation'
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('/activation-feature-map');
  };

  return(
    <Modal centered onClose={handleClose} opened={opened} size="xl" styles={{
      title: {
        fontSize: '30px',
        fontWeight: 600
      }
    }} title="File Berhasil Diunggah, Periksa Status Aktivasi Fitur MAP Pangkalan Di Bawah">
      <CardFeatureSummary listFeature={listFeature}
        selectedFeature={selectedFeature}
        type={type}/>
      <Flex direction="column" gap="md" mt="md">
        <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
          <Flex align="center" direction="row" gap="sm" pl={10}>
            <IconSuccess type={'small'} />
            <Text fw={500}>{summary.successTotal} Pangkalan Berhasil {type === 'activation' ? 'diaktifkan' : 'dinonaktifkan'} Fitur MAP
            </Text>
          </Flex>
        </Card>
        <Accordion radius="md" variant="contained">
          <Accordion.Item value="print">
            <Accordion.Control fw={500} icon={<IconFailed type={'small'} />} py=".2rem">
              {summary.failedTotal} Pelanggan Gagal {type === 'activation' ? 'diaktifkan' : 'dinonaktifkan'} Fitur MAP
            </Accordion.Control>
            <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
              {summary?.failedData?.map((item, index) => (
                <Grid grow justify="space-between" key={index} mt={10}>
                  <Grid.Col span={4}>
                    <Text fz={14}>ID Pangkalan: {item.registrationId}</Text>
                  </Grid.Col>
                  <Grid.Col span={4} ta="right">
                    <Text c="#CF212A" fz={14}>{item.reason}</Text>
                  </Grid.Col>
                </Grid  >
              ))}
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
        <Button fullWidth onClick={handleClose}>
          Tutup
        </Button>
      </Flex>
    </Modal>
  );
};

RenderModalSummaryBulkActivation.propTypes = {
  listFeature: PropTypes.array,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
  selectedFeature: PropTypes.array,
  summary: PropTypes.object,
  type: PropTypes.string
};

export const RenderModalLimitMaxCsv = ({
  message = null,
  opened = false,
  onClose = () => {}
}) => {
  return(
    <Modal centered onClose={onClose} opened={opened} radius={12} size="lg" styles={{
      title: {
        fontSize: 30 } }} title="Tidak Dapat Diproses">
      <Text c="#52575C" fz={18}mb="md">{message}</Text>
      <Button fullWidth onClick={onClose}>Tutup</Button>
    </Modal>
  );
};

RenderModalLimitMaxCsv.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  opened: PropTypes.bool
};
